module.exports = __webpack_public_path__ + "img/23_96.92dae306.png";